<template>
    <div v-if="series.length" class="flex flex-col">
        <series-grid-section
            :series="series"
            class="flex-grow pt-32"
        ></series-grid-section>
    </div>
</template>

<script>
import { mapState } from "vuex";
import SeriesGridSection from "../components/SeriesGridSection";

export default {
    name: "series",

    components: { SeriesGridSection },

    created() {
        this.$store.dispatch("FETCH_SERIES");
    },

    computed: {
        ...mapState(["series"])
    }
};
</script>
